module.exports = __webpack_public_path__ + "static/img/RedBubble@2x.3615f22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pride/places/RedBubble@2x.png
// module id = kTEY
// module chunks = 0